import React from 'react';
import "../assets/css/styles.table.css"
import Layout from './Layout';
//for table
import   DialogComponent  from '../components/DialogComponent'; 
import DynamicDataGridComponent from '../components/DynamicDataGrid';
import VirtualizedSelect from 'react-virtualized-select';
import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
import {useResourceDashboardHook} from '../hook/ResourceDashboardHook'
const ResourceDashboard = () => {
  const {Chart6Paging,pageChart6,projectList,handleSelectedProject,selectedOptionProject,engineer,getMonth,getYear,
              Chart3Paging,pageChart3,dialogopen,setdialogopen,resourceName,type,columns,rows,roleAccess,handleDynamicAction,
              handleTimeline,headerText,content0,content1,GetMonth,GetYear
      } = useResourceDashboardHook();
 
  return (
    <>
       <Layout>
                <div className='pd'><b>RESOURCE DASHBOARD</b> </div>
                <div className='pd'>
                <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>PROJECTS UNDER WORK | TOTAL TASK (Click the bar to see the detail)
                           <div style={{position:'absolute', right:15,top:20}}>
                              <button type='button'  onClick={(e) => Chart6Paging(pageChart6 - 1)}>Prev</button>  <button type='button'  onClick={(e) => Chart6Paging(pageChart6 + 1)}>Next</button>
                            </div>
                           </div>
                           <div id="chart6"></div>
                       </div>
                </div>
                <div className="projectsection1">
                       <div className='projectheaderBox5' >
                            <div style={{display:"flex"}} >
                                <div style={{flex:1, backgroundColor:"gray", paddingTop:15}} className='subcontent'>Select Employee</div>
                                <div style={{flex:2} } className='subcontent'>
                                    <VirtualizedSelect
                                        options={projectList}
                                        onChange={(option) => handleSelectedProject(option.value)}
                                        value={selectedOptionProject}
                                        clearable={false}
                                        searchable={true}
                                        required
                                    />
                                </div>
                            </div>
                            <div style={{display:"flex", textAlign:"center"}} >
                                <div className='subcontent2' style={{paddingTop:25}}>
                                TASK ASSIGNED<br/>
                                  {engineer.length}
                                </div>
                                <div>&nbsp;&nbsp;</div>
                                <div className='subcontent2' style={{paddingTop:25}}>
                                COMPLETED TASK<br/>
                                  {engineer.filter((engineer) => engineer.id_status==3).length}
                                </div>
                            </div>
                            <div style={{display:"flex", textAlign:"center"}} >
                                <div className='subcontent2' style={{paddingTop:25}}>
                                DEADLINE IN THIS MONTH<br/>
                                  {engineer.filter((engineer) => GetMonth(engineer.sebenarnya_selesai)==GetMonth(Date.now())).length}
                                </div>
                                <div>&nbsp;&nbsp;</div>
                                <div className='subcontent2' style={{paddingTop:25}}>
                                DEADLINE IN NEXT MONTH<br/>
                                  {engineer.filter((engineer) => GetMonth(engineer.sebenarnya_selesai)==GetMonth(Date.now()) + 1).length}
                                </div>
                            </div>
                            <div style={{display:"flex", textAlign:"center"}} >
                                <div className='subcontent2' style={{paddingTop:25}}>
                                DEADLINE IN THIS YEAR<br/>
                                  {engineer.filter((engineer) => GetYear(engineer.sebenarnya_selesai)==GetYear(Date.now())).length}
                                </div>
                                <div>&nbsp;&nbsp;</div>
                                <div className='subcontent2' style={{paddingTop:25}}>
                                DEADLINE IN NEXT YEAR<br/>
                                  {engineer.filter((engineer) => GetYear(engineer.sebenarnya_selesai) == GetYear(Date.now()) + 1).length}
                                </div>
                            </div>
                       </div>
                       <div className='projectheaderBox5'>
                       <div className='title'>TASK BY STATUS</div>
                        <div id="chart2"></div>
                        </div>


                </div>
                <div className="projectsection3">
                        <div className='projectheaderBox2'>
                           <div className='title'>TASK(%) BASED ON PROGRESS
                           <div style={{position:'absolute', right:15,top:20}}>
                              <button type='button'  onClick={(e) => Chart3Paging( pageChart3 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart3Paging(pageChart3 + 1)}>Next</button>
                            </div>
                           </div>
                           <div id="chart3"></div>
                       </div>
                </div>
                {/* <div className="projectsection3">
                        <div className='projectheaderBox2'>
                        <div className='title'>-3 BULAN | BULAN INI | +7 BULANAN
                            <div className="headerChart5">

                                <div><button>HARIAN</button></div>
                                <div><button>MINGGUAN</button></div>
                                <div><button>TAHUNAN</button></div>
                            </div>
                        </div>
                        <div style={{paddingTop:150}}>
                            <table border={0} style={{padding:0,margin:0}} width={"100%"} >
                                <tr>
                                    <td><img src={startgaris3} width={70} height={59} /></td>
                                    <td><img src={garis1} width={70} height={59}/></td>
                                    <td><img src={garis1} width={70} height={59}/></td>
                                    <td><img src={garis1} width={70} height={59}/></td>
                                    <td> <img src={garis1} width={70} height={59}/></td>
                                    <td><img src={garis2} width={70} height={59}/></td>
                                    <td> <img src={garis2} width={70} height={59}/></td>
                                    <td> <img src={garis1} width={70} height={59}/></td>
                                    <td> <img src={garis2} width={70} height={59}/></td>
                                    <td> <img src={garis2} width={70} height={59}/></td>
                                    <td> <img src={endgaris1} width={70} height={auto}/></td>
                                </tr>

                                <tr  style={{height:20, fontSize:12,textAlign:"center"}}>
                                    <td>Jun 2024</td>
                                    <td>Jul 2024</td>
                                    <td>Aug 2024</td>
                                    <td>Bulan<br></br>Ini</td>
                                    <td>Oct 2024</td>
                                    <td>Nov 2024</td>
                                    <td>Dec 2024</td>
                                    <td>Jan 2025</td>
                                    <td>Feb 2025</td>
                                    <td>Mar 2025</td>
                                    <td>Apr 2025</td>
                                </tr>
                                <tr>
                                    <td colSpan={11}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td></td>
                                </tr>
                            </table>
                          </div>
                           <div ></div>
                       </div>
                </div> */}
                {/* <div className="projectsection3">
                        <div className='projectheaderBox6'>
                           <div className='title'>MILESTONES PEMETAAN</div>
                           <VirtualizedSelect 
                                options={projectList}
                                onChange={(option) => handleSelectedProject(option.value)}
                                value={selectedOptionProject}
                                clearable={false}
                                searchable={true}
                                required
                            /> 
                           <div>
                            <table width={"100%"} border={1} style={{fontSize:12}}>
                            <tr style={{backgroundColor :"#E9E9E9", textAlign:"center", height:30}}>
                                <td style={{width:150}}>2018</td>
                                <td>Jan</td>
                                <td>Feb</td>
                                <td>Mar</td>
                                <td>Apr</td>
                                <td>Mei</td>
                                <td>Jun</td>
                                <td>Jul</td>
                                <td>Agu</td>
                                <td>Sep</td>
                                <td>Okt</td>
                                <td>Nov</td>
                                <td>Des</td>
                                <td>TOTAL</td>
                            </tr>
                            
                              {getTanggal().map((tgl, index) => (
                                <tr style={{height:30}}>
                                    <td style={{backgroundColor :"#E9E9E9", textAlign:"center"}}>{tgl}</td>
                                {getBulan().map((bln, index2) => (
                                     
                                     getCellData(bln,tgl) == 0 ? <td style={{backgroundColor:"#F2F2F2"}}>&nbsp;</td> : <td style={{textAlign:"center", backgroundColor:"#4EB392", color:"white"}}>{getCellData(bln,tgl)} </td>
                                    
                                ))}
                                    <td style={{backgroundColor :"#E9E9E9", textAlign:"center"}}>{GetRowTotal(tgl)}</td>
                                </tr>
                            ))}
                            <tr style={{textAlign:"center", backgroundColor :"#E9E9E9"}}>
                            <td >TOTAL</td>
                            { getBulan().map((bln, index2) => (
                               <td>{GetColumnTotal(bln)}</td>
                             ))}
                             <td>{Total}</td>
                            </tr>
                            <tr style={{textAlign:"center", backgroundColor :"#E9E9E9"}}>
                            <td >HARI KERJA </td>
                            { getBulan().map((bln, index2) => (
                                <td>{hariKerja[bln-1] && hariKerja[bln-1].days}</td>
                             ))}
                             <td>{totalHariKerja}</td>
                            </tr>

                             <tr style={{textAlign:"center", backgroundColor :"#E9E9E9"}}>
                            <td >RATA RATA HARIAN </td>
                            { getBulan().map((bln, index2) => (
                                <td>{ (parseInt(GetColumnTotal(bln)) /  parseInt(hariKerja[bln-1] && hariKerja[bln-1].days)).toFixed(2)}</td>
                             ))}
                             <td>{(parseInt(Total) / parseInt(totalHariKerja)).toFixed(2)}</td>
                            </tr>  
                            </table>
                           </div>
                       </div>
                </div> */}

                </div>


                <DialogComponent dialogopen={dialogopen} dialogclose={setdialogopen} title={resourceName + "'s Project"}>
                      {type === "Project" && (
                        <>
                             <DynamicDataGridComponent customcolumns={columns} rows={rows} name="dg" rowid="id" width={[50,60,450,100,50]} roleaccess={roleAccess} handleDynamicAction={handleDynamicAction}></DynamicDataGridComponent><br></br>    
                              {/* <DynamicDataGridComponent  rows={rows} name="dg" rowid="id" handleDynamicAction={handleDynamicAction} roleaccess={roleAccess} width={[50,60,450,100,50]}></DynamicDataGridComponent><br></br>  */}
                    
                        </>
                        
                      )}

                      {type === "Task" && (
                         <TabComponent  height={300} width={"100%"} onClick={(event) => {
                          var target = event.target.closest('.e-toolbar-item');
                          if (target) {
                            if(target.innerText == "GANTT"){
                              handleTimeline('day') 
                            }
                          }
                         }}>
                          <TabItemsDirective>
                            <TabItemDirective   header={headerText[0]} content={content0}/>
                            <TabItemDirective header={headerText[1]} content={content1}/>
                          </TabItemsDirective>
                        </TabComponent>
                            
                        
                      )}
                      

                </DialogComponent>
                </Layout>
    </>
  );
};

export default ResourceDashboard;